import { useCurrentTalentProfile } from "@/shared/stores/useProfile";
import { useErrorResponse } from "@/shared/hooks";
import { useGetUserProfile } from "@/shared/api/user.api";
import { ScreenLoader } from "@/shared/components";
import { TalentRoutes, UserRoutes, GuestRoutes, OrganizationRoutes } from "@/roles";
import { USER_TYPES } from "@/shared/constants";
import { useEffect } from "react";
import { useAuth } from "@/shared/stores/useAuth";
import { useCurrentOrganization } from "@/modules/organization/useCurrentOrganization";

export default function AppRouter(): JSX.Element {
  const { currentProfile } = useCurrentTalentProfile();
  const { isOrganizationWorkspace } = useCurrentOrganization();
  const { setUser } = useAuth();

  const {
    data: user,
    error,
    isLoading: userLoading,
  } = useGetUserProfile({
    key: ["user-profile"],
  });

  useErrorResponse(error);
 console.log(user, "user in app routes");
  useEffect(() => {
    if (user?.data) {
      console.log(user.data, "user.data in app routes");
      setUser(user.data);
    }
  }, [user]);

  if (userLoading) {
    return <ScreenLoader />;
  }

  const isAuthenticated = !!user?.data;

  if (!isAuthenticated) {
    return <GuestRoutes />;
  }

  if (user.data.account_type === USER_TYPES.ORGANIZATION || isOrganizationWorkspace) {
    return <OrganizationRoutes />;
  }

  if (currentProfile) {
    return <TalentRoutes />;
  }

  return <UserRoutes />;
}
